var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeveloperRoleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.406,
    height: 22.403,
    viewBox: "0 0 22.406 22.403",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pencil",
    transform: "translate(0.051 0.05)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1787",
    "data-name": "Group 1787",
    transform: "translate(0.001 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2998",
    "data-name": "Path 2998",
    d: "M20.971,14.6a4.521,4.521,0,0,0-4.519-1.121l-1.592-1.592,6.957-6.957a1.666,1.666,0,0,0,0-2.356L19.729.488a1.666,1.666,0,0,0-2.356,0L10.416,7.445,8.824,5.853A4.512,4.512,0,0,0,2.693.394.436.436,0,0,0,2.56,1.1L4.638,3.179,3.169,4.649,1.091,2.57A.436.436,0,0,0,.384,2.7,4.512,4.512,0,0,0,5.842,8.834l1.592,1.592L2.106,15.754A.44.44,0,0,0,2,15.926L.1,21.65a.436.436,0,0,0,.55.55l5.719-1.9A.525.525,0,0,0,6.55,20.2l5.328-5.328,1.592,1.592A4.512,4.512,0,0,0,19.6,21.92a.436.436,0,0,0,.132-.707l-2.078-2.078,1.469-1.469L21.2,19.744a.436.436,0,0,0,.707-.132,4.512,4.512,0,0,0-.939-5.01ZM17.989,1.1a.795.795,0,0,1,1.124,0L21.2,3.192a.795.795,0,0,1,0,1.124L19.787,5.729,16.575,2.517ZM6.266,8.026a.436.436,0,0,0-.462-.1A3.643,3.643,0,0,1,.969,3.681L2.861,5.573a.436.436,0,0,0,.616,0L5.562,3.487a.436.436,0,0,0,0-.616L3.671.98A3.643,3.643,0,0,1,7.916,5.814a.436.436,0,0,0,.1.462L9.8,8.061,8.051,9.81ZM1.2,21.1l.63-1.9L3.1,20.471Zm2.827-.937-1.89-1.89.465-1.4L5.435,19.7Zm2.212-.89-1.3-1.3c-.261-.253-.007,0-.616-.616l-1.3-1.3L15.959,3.133l.035.035,1.263,1.263c.9.892-.082-.1.616.616l1.3,1.3Zm15.083-.64-1.892-1.892a.436.436,0,0,0-.616,0l-2.085,2.085a.436.436,0,0,0,0,.616l1.892,1.892A3.643,3.643,0,0,1,14.378,16.5a.436.436,0,0,0-.1-.462l-1.784-1.784L14.243,12.5l1.784,1.784a.435.435,0,0,0,.462.1,3.643,3.643,0,0,1,4.835,4.245Z",
    transform: "translate(-0.001 0)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeveloperRoleIcon);
export default __webpack_public_path__ + "static/media/developer-role-icon.3f0d5cb3227e137d909df017f5ff3a73.svg";
export { ForwardRef as ReactComponent };